import React, { FunctionComponent } from 'react';
import ScrollCarousel from './ScrollCarousel';

type Props = {
    images: string[];
};

const Carousel: FunctionComponent<Props> = ({ images }) => <ScrollCarousel images={images} />;
export default Carousel;
